module.exports = __webpack_public_path__ + "static/media/appointment.a4efcbe1.png";